<template>
  <div class="fondo-polaroid">
    <img src="@/assets/clima.avif" alt="fondo" class="fondo-imagen" />
    <div class="overlay"></div>

    <!-- MARCO -->
    <div class="marco-polaroid">
      <img :src="currentImage" class="foto-polaroid" alt="imagen actual" />
    </div>

    <!-- TEXTO DE INVITACIÓN -->
    <p ref="textoRef" class="texto-invitacion">
      Con todo nuestro amor, nuestra invitación
    </p>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'PolaroidGallery',
  setup() {
    const imagenes = [
      new URL('@/assets/PP_converted.webp', import.meta.url).href,
      new URL('@/assets/PP1_converted.webp', import.meta.url).href,
            new URL('@/assets/PP2_converted.webp', import.meta.url).href,

                  new URL('@/assets/PP3_converted.webp', import.meta.url).href,

                        new URL('@/assets/PP4_converted.webp', import.meta.url).href,

    ]

    const currentImage = ref(imagenes[0])
    let index = 0

    const textoRef = ref(null)

    onMounted(() => {
      // Cambio de imagen automática
      setInterval(() => {
        index = (index + 1) % imagenes.length
        currentImage.value = imagenes[index]
      }, 2000)

      // Animación GSAP + Intersection
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          gsap.fromTo(
            textoRef.value,
            { opacity: 0, y: 60, rotateZ: -5 },
            {
              opacity: 1,
              y: 0,
              rotateZ: 0,
              duration: 1.6,
              ease: 'power4.out'
            }
          )
          observer.disconnect()
        }
      }, { threshold: 0.5 })

      if (textoRef.value) observer.observe(textoRef.value)
    })

    return { currentImage, textoRef }
  }
}
</script>

<style scoped>
.fondo-polaroid {
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.fondo-imagen {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: grayscale(100%);
  z-index: 0;
}

.overlay {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.marco-polaroid {
  position: relative;
  width: 330px;
  padding: 12px;
  background-color: white;
  border: 12px solid white;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.6);
  z-index: 2;
  text-align: center;
}

.foto-polaroid {
  width: 100%;
  display: block;
  border: none;
  object-fit: cover;
}

.texto-invitacion {
  z-index: 2;
  margin-top: 20px;
  font-family: 'say2', cursive;
  font-size: 20px;
  color: white;
  padding: 10px 20px;
  border-radius: 8px;
  text-align: center;
  transform-origin: bottom center;
}
</style>
